<template>
    <div class="search-box">
      <el-form
        ref="searchFormRef"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="职业" prop="roleName">
          <el-input v-model="formInline.roleName" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-box">
      <div class="table-btns">
        <el-button type="primary" @click="addFn">新增</el-button>
        <el-button
          type="danger"
          :disabled="selectionTable.length == 0"
          @click="batchDelFn"
          >批量删除</el-button
        >
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column type="index" label="序号" align="center" width="90" />
        <el-table-column prop="roleName" label="职业" align="center" />
        <el-table-column prop="trialNum" label="试刷题数量" align="center" />
        <el-table-column prop="createTime" label="创建时间" align="center" />
        <el-table-column prop="address" label="操作" align="center">
          <template #default="scope">
            <el-button type="primary" size="small" @click="editFn(scope.row)"
              >修改</el-button
            >
            <el-button type="danger" size="small" @click="delFn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 50, 100, 200]"
        :small="small"
        :disabled="disabled"
        :background="background"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      v-model="dialogVisible"
      append-to-body
      :close-on-click-modal="false"
      :width="600"
      :title="dialogTitle"
    >
      <userAddEditDialog
        v-if="dialogVisible"
        ref="addEditDialogRef"
        @dialogClose="dialogClose"
      />
    </el-dialog>
  </template>
  
  <script setup>
  import { reactive, ref, onMounted, nextTick } from "vue";
  import { ElMessageBox, ElMessage } from "element-plus";
  import userAddEditDialog from "./dialog/userAddEditDialog.vue";
  import { roleList, roleDelete } from "@/http/http";
  let dialogVisible = ref(false);
  let dialogTitle = ref("");
  let addEditDialogRef = ref(null);
  const tableData = ref([]);
  let selectionTable = ref([]);
  const addFn = () => {
    dialogVisible.value = true;
    dialogTitle.value = "新增";
  };
  const editFn = (row) => {
    dialogVisible.value = true;
    dialogTitle.value = "修改";
    nextTick(() => {
      addEditDialogRef.value.init(row);
    });
  };
  const batchDelFn = () => {
    ElMessageBox.confirm("请确认是否删除？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
      closeOnClickModal: false,
    }).then(() => {
      console.log(selectionTable.value);
      let ids = [];
      selectionTable.value.forEach((item) => {
        ids.push(item.id);
      });
      _roleDelete(ids.join());
    }).catch(() => {

    })
  };
  const delFn = (row) => {
    ElMessageBox.confirm("请确认是否删除？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
      closeOnClickModal: false,
    }).then(() => {
      _roleDelete(row.id);
    }).catch(() => {
        
    })
  };
  const _roleDelete = (ids) => {
    roleDelete(ids).then((res) => {
      if (res.data.code == 200) {
        ElMessage({
          message: res.data.message,
          type: "success",
        });
        _userList();
      }
    });
  };
  
  const formInline = reactive({
    roleName: "",
  });
  const searchFormRef = ref();
  const onSubmit = () => {
    _userList();
  };
  const currentPage = ref(1);
  const pageSize = ref(10);
  const total = ref(0);
  const handleSizeChange = (val) => {
    pageSize.value = val;
    _userList();
  };
  const handleCurrentChange = (val) => {
    currentPage.value = val;
    _userList();
  };
  const handleSelectionChange = (val) => {
    selectionTable.value = val;
  };
  const _userList = () => {
    roleList({
      size: pageSize.value,
      current: currentPage.value,
      ...formInline,
    }).then((res) => {
      tableData.value = res.data.data.records;
      total.value = res.data.data.total;
    });
  };
    const dialogClose = (flag) => {
    dialogVisible.value = false;
    if (flag) {
        onSubmit();
    }
    };
  onMounted(() => {
    _userList();
  });
  </script>
  <style scoped lang="scss">
  .success {
    color: #02bc6c;
  }
  </style>
  